<template>
    <div class="svg--icon" v-html="svg"></div>
</template>

<script>
export default {
  name: 'SVGLoader',
  props: {
    src: String
  },
  computed: {
    svg: function () {
      return require('../assets/img/svg/' + this.src)
    }
  }
}
</script>
